interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Exact "list (1)" asset from the Create-menu Figma dropdown. */
const FigmaTableIcon = ({ width = 16, height = 16, color = '#121826' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.33301 4.66663H14.9997C15.2649 4.66663 15.5192 4.56127 15.7068 4.37373C15.8943 4.1862 15.9997 3.93184 15.9997 3.66663C15.9997 3.40141 15.8943 3.14706 15.7068 2.95952C15.5192 2.77198 15.2649 2.66663 14.9997 2.66663H5.33301C5.06779 2.66663 4.81344 2.77198 4.6259 2.95952C4.43836 3.14706 4.33301 3.40141 4.33301 3.66663C4.33301 3.93184 4.43836 4.1862 4.6259 4.37373C4.81344 4.56127 5.06779 4.66663 5.33301 4.66663Z'
        fill={color}
      />
      <path
        d='M14.9997 7.33337H5.33301C5.06779 7.33337 4.81344 7.43873 4.6259 7.62627C4.43836 7.8138 4.33301 8.06816 4.33301 8.33337C4.33301 8.59859 4.43836 8.85294 4.6259 9.04048C4.81344 9.22802 5.06779 9.33337 5.33301 9.33337H14.9997C15.2649 9.33337 15.5192 9.22802 15.7068 9.04048C15.8943 8.85294 15.9997 8.59859 15.9997 8.33337C15.9997 8.06816 15.8943 7.8138 15.7068 7.62627C15.5192 7.43873 15.2649 7.33337 14.9997 7.33337Z'
        fill={color}
      />
      <path
        d='M14.9997 12H5.33301C5.06779 12 4.81344 12.1054 4.6259 12.2929C4.43836 12.4804 4.33301 12.7348 4.33301 13C4.33301 13.2652 4.43836 13.5196 4.6259 13.7071C4.81344 13.8946 5.06779 14 5.33301 14H14.9997C15.2649 14 15.5192 13.8946 15.7068 13.7071C15.8943 13.5196 15.9997 13.2652 15.9997 13C15.9997 12.7348 15.8943 12.4804 15.7068 12.2929C15.5192 12.1054 15.2649 12 14.9997 12Z'
        fill={color}
      />
      <path
        d='M1.66667 5.33333C2.58714 5.33333 3.33333 4.58714 3.33333 3.66667C3.33333 2.74619 2.58714 2 1.66667 2C0.746192 2 0 2.74619 0 3.66667C0 4.58714 0.746192 5.33333 1.66667 5.33333Z'
        fill={color}
      />
      <path
        d='M1.66667 9.66667C2.58714 9.66667 3.33333 8.92047 3.33333 8C3.33333 7.07953 2.58714 6.33333 1.66667 6.33333C0.746192 6.33333 0 7.07953 0 8C0 8.92047 0.746192 9.66667 1.66667 9.66667Z'
        fill={color}
      />
      <path
        d='M1.66667 14.3333C2.58714 14.3333 3.33333 13.5871 3.33333 12.6667C3.33333 11.7462 2.58714 11 1.66667 11C0.746192 11 0 11.7462 0 12.6667C0 13.5871 0.746192 14.3333 1.66667 14.3333Z'
        fill={color}
      />
    </svg>
  );
};

export default FigmaTableIcon;
